var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_22199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.069 139.223L38.6401 170.652C34.7348 174.557 28.4032 174.557 24.4979 170.652L-17.9285 128.225C-21.8337 124.32 -21.8337 117.988 -17.9285 114.083L23.0837 73.071C26.9889 69.1658 33.3206 69.1658 37.2258 73.071L44.6548 80.5L76.0837 49.071C79.9889 45.1658 86.3206 45.1658 90.2258 49.071L132.652 91.4974C136.557 95.4027 136.557 101.734 132.652 105.64L91.6401 146.652C87.7348 150.557 81.4032 150.557 77.4979 146.652L70.069 139.223Z",
    fill: "#CCD1E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 32,
    r: 10,
    fill: "#CCD1E0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 116,
    height: 116,
    rx: 58,
    stroke: "white",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_22199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/Pic.9d7b474be2b757685682f79ab947eba0.svg";
export { ForwardRef as ReactComponent };